<template>
	<page enable-flex>
		<c-scroll-list ref="list" class="flex-grow">
			<template #default="{data, index}">
				<view-list-card :key="index" :data="data" @click="clickHandle(data, $event)">
					<template #name>
						<c-checkbox :value="checkList.includes(data.id)" readonly></c-checkbox>
						<span style="margin-left: .15rem;">单号：{{data.order_no}}</span>
					</template>

					<template #total>
						<view-list-total name="结算" :value="'￥' + data.check_receipt_money"></view-list-total>
					</template>

					<template #default>
						<c-field label="商品信息">{{[data.brand_name, data.model_name, data.color_name, data.memory_name].filter(item => item).join(' ')}}</c-field>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="订单结算金额"><b style="color: #000;">￥{{data.check_product_money}}</b></c-field>
						<c-field v-if="data.check_return_money" label="售后金额"><span style="color: #f55;">{{data.check_return_money}}</span></c-field>
						<c-field v-if="data.check_supplement_money" label="商品补差金额"><span style="color: #f55;">{{data.check_supplement_money}}</span></c-field>
						<c-field label="创建时间">{{data.order_create_date}}</c-field>
					</template>
				</view-list-card>
			</template>
		</c-scroll-list>

		<template #button>
			<div class="foot flex-center">
				<c-checkbox :value="allCheckState" @change="allCheckHandle">全选</c-checkbox>
				<p class="foot-total flex-grow">已选：{{checkList.length}}条 共<span>￥{{sumTotal}}</span></p>
				<c-button class="foot-button" size="form" color="main" @click="submitHandle">去提现</c-button>
			</div>
		</template>
	</page>
</template>

<script>
import saasDeposit from '@/mixins/saas_deposit';

	export default {
    mixins: [saasDeposit],
		data() {
			return {
				checkList: [],
				total: 0,
				sumTotal: 0,
				allCheckState: false
			}
		},

		watch: {
			checkList() {
				let sum = 0;
				this.$refs.list && this.$refs.list.getData().forEach(item => {
					if (this.checkList.includes(item.id)) {
						sum += item.check_receipt_money;
					}
				});
				this.sumTotal = parseFloat(sum.toFixed(2));
				this.allCheckState = this.total > 0 && this.checkList.length == this.total;
			},

			total() {
				this.allCheckState = this.total > 0 && this.checkList.length == this.total;
			}
		},

		mounted() {
			this.update();
			this.$onShow(() => {
				this.checkList = [];
				this.allCheckState = false;
				this.$refs.list.update();
			});
		},

		methods: {
			update() {
				this.$refs.list.load({
					url: '/withdraw/operable/order/list',
					response: res => {
						this.total = res.total;
					}
				});
			},

			clickHandle(data) {
				if (this.checkList.includes(data.id)) {
					this.checkList.splice(this.checkList.findIndex(temp => temp == data.id), 1);
				} else {
					this.checkList.push(data.id);
				}
			},

			allCheckHandle(state) {
				if (state) {
					this.checkList = this.$refs.list.getData().map(item => item.id);
				} else {
					this.checkList = [];
				}
				this.allCheckState = state;
			},

			submitHandle() {
				this.checkDepositBefore(() => {
					if (!this.checkList.length) {
						this.$message({
							message: '请选择要提现的订单'
						});
						return;
					}
					this.mp.navigateTo('/pages/wallet/withdraw', {
						type: 2,
						orderId: this.checkList.join(','),
						sum: this.sumTotal
					});
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .card {
		margin-top: .2rem;
	}

	>>> .count {
		div {
			color: #FF6900;
		}
	}

	.foot {
		width: 100%;

		&-total {
			margin: 0 .2rem;
			font-size: .24rem;
			color: #666;

			span {
				color: #FF6900;
			}
		}

		&-button {
			max-width: 2.4rem;
		}
	}
</style>